import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun PublicPlayersScreen(season: SeasonDto?) {
    var players by remember { mutableStateOf<List<PlayerStatDto>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(season?.id) {
        val currentSeason = season
        if (currentSeason == null) {
            loading = false
            return@LaunchedEffect
        }
        loading = true
        try {
            players = Api.fetchPlayerStats(null, seasonId = currentSeason.id)
            error = null
        } catch (e: Throwable) {
            error = "Načtení žebříčku selhalo: ${e.apiMessage()}"
        }
        loading = false
    }

    Div(attrs = { classes("card") }) {
        if (season == null) {
            Text("Právě není žádná aktivní sezóna.")
        } else {
            if (loading) Text("Načítám…")
            error?.let { Div { Text("Chyba: $it") } }
            Text("Napříč všemi ligami sezóny ${season.name}, řazeno podle průměru.")

            PlayerRankingTable(players)
        }
    }
}
